import { convertSecondsToTimer } from '../../../helpers';
// Formats playback time as m:ss
export function formatAudioTime(seconds) {
    if (seconds === null || seconds === undefined || !isFinite(seconds) || seconds < 0) {
        return '--:--';
    }
    return convertSecondsToTimer(Math.floor(seconds));
}
function xmur3(str) {
    let h = 1779033703 ^ str.length;
    for (let i = 0; i < str.length; i++) {
        h = Math.imul(h ^ str.charCodeAt(i), 3432918353);
        h = (h << 13) | (h >>> 19);
    }
    return () => {
        h = Math.imul(h ^ (h >>> 16), 2246822507);
        h = Math.imul(h ^ (h >>> 13), 3266489909);
        return (h ^= h >>> 16) >>> 0;
    };
}
// Deterministic decorative waveform
export function generateWaveformBars(seed, count = 28) {
    const next = xmur3(seed);
    const bars = [];
    for (let i = 0; i < count; i++) {
        bars.push(0.25 + (next() / 4294967296) * 0.75);
    }
    return bars;
}
// Converts a pointer's physical clientX into a playback fraction [0, 1]
export function getSeekFraction(clientX, rect, isRtl) {
    if (rect.width <= 0)
        return 0;
    const raw = Math.min(1, Math.max(0, (clientX - rect.left) / rect.width));
    return isRtl ? 1 - raw : raw;
}
